import { MotionConfig } from 'framer-motion';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import './index.css';
import { CreateRoomScreen } from './screens/CreateRoomScreen';
import { CornerLab } from './routes/CornerLab';
import { MockGallery } from './routes/MockGallery';
import { RoomRoute } from './routes/RoomRoute';
import { StylePlate } from './routes/StylePlate';

const router = createBrowserRouter([
  { path: '/', element: <CreateRoomScreen /> },
  { path: '/r/:roomToken', element: <RoomRoute /> },
  { path: '/r/:roomToken/projector', element: <RoomRoute projector /> },

  // Design references, not part of the app.
  { path: '/style', element: <StylePlate /> },
  { path: '/mocks', element: <MockGallery /> },
  { path: '/corners', element: <CornerLab /> },

  { path: '*', element: <CreateRoomScreen /> },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Motion carries the drama here, so honouring the OS preference matters. */}
    <MotionConfig reducedMotion="user">
      <RouterProvider router={router} />
    </MotionConfig>
  </StrictMode>,
);
